import { Span } from "../Typography";
import { Box, styled } from "@mui/system";
import { InputBase } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import { FC, useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import { GullButton } from "../buttons/GullButton";
import { tableBodyData } from "./sorted-table-data";
import useCommonContext from "../../hooks/useCommonContext";
import muiIcons from "../icons/mui-icons";

const Search = styled("div")(({ theme }) => ({
  padding: ".2rem 0rem",
  position: "relative",
  borderRadius: "5px",
  width: "250px",
  backgroundColor: theme.palette.mode === "light"
    ? theme.palette.grey[100] : "#0000002e",
  "&:hover": {
    backgroundColor: theme.palette.mode === "light" && theme.palette.grey[200],
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    fontSize: 24,
    marginTop: "-5px",
    color: theme.palette.grey.main,
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    width: "100%",
  },
}));

interface Props {
  numSelected: number;
  setFilteredTableData: (value: any[]) => void;
}
const SortedTableToolbar: FC<Props> = (props) => {
  const { SearchIcon, DeleteIcon } = muiIcons;
  const { setFormModal } = useCommonContext();
  const { numSelected, setFilteredTableData } = props;

  const [searchValue, setSearchValue] = useState<string>("");
  useEffect(() => {
    if (searchValue.length > 0) {
      const searchResult = tableBodyData.filter((item) =>
        item.name.toLocaleLowerCase().match(searchValue.toLowerCase())
      );
      setFilteredTableData(searchResult);
    } else {
      setFilteredTableData(tableBodyData);
    }
  }, [searchValue]);

  return (
    <Toolbar
      sx={{
        pl: "0px !important",
        pr: "0px !important",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Search>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search By Name"
          inputProps={{ "aria-label": "search" }}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </Search>
      {numSelected > 0 ? (
        <Box display="flex" alignItems="center">
          <Span sx={{ mr: "20px" }} color="inherit">
            {numSelected} selected
          </Span>
          <Tooltip title="Delete" placement="top">
            <IconButton>
              <DeleteIcon sx={{ fontSize: 24 }} />
            </IconButton>
          </Tooltip>
        </Box>
      ) : (
        <GullButton
          variant="contained"
          color="primary"
          sx={{ p: ".5rem 1.2rem", fontWeight: "bold" }}
          onClick={() => setFormModal(true)}
        >
          Add Customer
        </GullButton>
      )}
    </Toolbar>
  );
};

export default SortedTableToolbar;
